// extracted by mini-css-extract-plugin
export default {"table":"table_table__719J7","cellWrapper":"table_cellWrapper__tADhn","image":"table_image__NxoPP","productStatus":"table_productStatus__dktz-"};